import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";

import JaoLogo from "components/jaoLogo";
import Title from "components/title";

type NotFoundProps = WithTranslation;

const NotFound = ({ t }: NotFoundProps) =>
    <div className="h-100 d-flex flex-column">
        <div className="d-flex flex-grow-1 align-items-center justify-content-center">
            <div style={{ padding: "100px", background: "white" }}>
                <div className="p-3">
                    <JaoLogo />
                </div>
                <Title text={t("common:pageNotFound")} />
            </div>
        </div>
    </div>;

export default withTranslation()(NotFound);